import { isValidHex } from '../../../utils/color.js';

var script = {
  name: 'ColorPickerInput',
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    },
    valueKey: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    max: {
      type: Number,
      default: 255
    },
    min: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  methods: {
    onEscKeydown() {
      this.$refs.input.blur();
    },
    onInput(event) {
      const {
        value
      } = event.target;
      this.$emit('change', {
        [this.valueKey]: value
      });
      if (!this.$refs.input) {
        return;
      }
      this.$refs.input.value = value;
    },
    onBlur(event) {
      if (this.disabled) {
        return;
      }
      if (this.valueKey === 'hex') {
        this.onInput(event);
        if (!isValidHex(event.target.value)) {
          this.$refs.input.value = this.value;
        }
      }
      this.$emit('blur', event);
    },
    onFocus(event) {
      if (this.disabled) {
        return;
      }
      this.$emit('focus', event);
    }
  }
};

export { script as default };
//# sourceMappingURL=color-picker-input.vue2.js.map
